import { configureStore } from '@reduxjs/toolkit';
import userReducer from './user/userSlice';
import uploadReducer from './upload/uploadSlice';
import processingReducer from './processing/processingSlice';
import systemReducer from './system/systemSlice';
import tabReducer from './tab/tabSlice';

export const store = configureStore({
	reducer: {
		user: userReducer,
		upload: uploadReducer,
		processing: processingReducer,
		system: systemReducer,
		tab: tabReducer,
	},
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
